import { render, staticRenderFns } from "./ImportPropertiesComponent.vue?vue&type=template&id=85ac66fc&"
import script from "./ImportPropertiesComponent.vue?vue&type=script&lang=js&"
export * from "./ImportPropertiesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports